"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _react = _interopRequireWildcard(require("react"));
var _reactDraggable = _interopRequireDefault(require("react-draggable"));
var _reactResponsive = require("react-responsive");
var _SttBox = _interopRequireDefault(require("../../../SttLayout/SttBox"));
var _SttHidden = _interopRequireDefault(require("../../../SttLayout/SttHidden"));
var _ConteudoTooltipHelpdesk = _interopRequireDefault(require("./ConteudoTooltipHelpdesk"));
var _SttAssistenteChat = _interopRequireDefault(require("./SttAssistenteChat"));
var _atendenteOffline = _interopRequireDefault(require("./img/atendente-offline.png"));
var _atendenteOnline = _interopRequireDefault(require("./img/atendente-online.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PERFIL_ASSISTENTE_PADRAO = 'gestor';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    menuUsuario: {
      right: 10
    },
    boxMenu: {
      position: 'fixed',
      display: 'flex',
      overflow: 'hidden',
      padding: 0,
      spacing: 0,
      right: 20,
      bottom: 20,
      zIndex: 1500,
      height: 70,
      width: 70,
      borderRadius: theme.spacing(0.5),
      cursor: 'pointer'
    },
    tooltipContent: {
      pointerEvents: 'none'
    }
  };
});
var HtmlTooltip = (0, _core.withStyles)(function (theme) {
  return {
    tooltip: {
      boxShadow: '4px 4px 4px 2px rgba(158,158,158,0.6)',
      backgroundColor: '#fefefe',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 240,
      minHeight: 50,
      height: 'auto',
      borderRadius: 12,
      padding: 10,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
      display: 'flex',
      justifyContent: "space-between",
      alignContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    },
    arrow: {
      "&:before": {
        border: "1px solid #E6E8ED",
        borderRadius: 3,
        boxShadow: '4px 2px 4px 2px rgba(158, 158, 158, 0.6)'
      },
      color: theme.palette.common.white,
      fontSize: 'xx-large',
      bottom: '1px !important'
    }
  };
})(_core.Tooltip);
var timeout = null;
var AtalhoHelpdesk = function AtalhoHelpdesk(_ref) {
  var config = _ref.config,
    usuario = _ref.usuario,
    headers = _ref.headers;
  var classes = useStyles();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    exibirHelpdesk = _useState2[0],
    setExibirHelpdesk = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    atendenteOnline = _useState4[0],
    setAtendenteOnline = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    tooltipIsOpen = _useState6[0],
    setTooltipIsOpen = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    urlHelpdesk = _useState8[0],
    setUrlHelpdesk = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    assistenteAberto = _useState10[0],
    setAssistenteAberto = _useState10[1];
  var STORAGE_KEY = 'stt-atalho-helpdesk-position';
  var _useState11 = (0, _react.useState)(function () {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (raw) {
          var parsed = JSON.parse(raw);
          return {
            x: Number(parsed.x) || 0,
            y: Number(parsed.y) || 0
          };
        }
      } catch (e) {}
      return {
        x: 0,
        y: 0
      };
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    axis = _useState12[0],
    setAxis = _useState12[1];
  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    minWidth: 1024
  });
  var perfilAssistente = config.assistente && config.assistente.perfil || PERFIL_ASSISTENTE_PADRAO;
  var ehGestor = Boolean(usuario && usuario.perfisRBAC && usuario.perfisRBAC.some(function (perfil) {
    return perfil.identificador === perfilAssistente;
  }));
  var mostrarAssistente = Boolean(config && config.assistente_ativo) && ehGestor;
  var mostrarHelpdesk = exibirHelpdesk;
  (0, _react.useEffect)(function () {
    var messageListener = function messageListener(e) {
      var _e$data, _e$data2;
      if (!e) return;
      var acao = ((_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.acao) || null;
      var data = ((_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.data) || null;
      if (acao === 'STATUS_ATENDENTE_CONECTADO_HELPDESK') {
        setAtendenteOnline(data.online);
        setUrlHelpdesk(data.urlHelpdesk);
      }
    };
    window.addEventListener('message', messageListener);
    return function () {
      window.removeEventListener('message', messageListener);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (usuario !== null && usuario !== void 0 && usuario.perfisRBAC && config.helpdesk_ativo) {
      var ehAtendente = usuario.perfisRBAC.some(function (p) {
        return p.identificador.includes('atendHelpdesk');
      });
      setExibirHelpdesk(!ehAtendente);
    } else {
      setExibirHelpdesk(false);
    }
  }, [usuario, config]);
  var eventHandler = function eventHandler(callback) {
    return function (event) {
      if (!isDesktop && event.type === 'touchstart') {
        callback(event);
      } else if (isDesktop && event.type === 'click') {
        callback(event);
      }
    };
  };
  var onClick = function onClick() {
    setTooltipIsOpen(function (open) {
      return !open;
    });
  };
  var onAbrirAssistente = function onAbrirAssistente() {
    setTooltipIsOpen(false);
    setAssistenteAberto(true);
  };
  var conteudoTooltip = /*#__PURE__*/_react["default"].createElement(_ConteudoTooltipHelpdesk["default"], {
    atendenteOnline: atendenteOnline,
    urlHelpdesk: urlHelpdesk,
    mostrarHelpdesk: mostrarHelpdesk,
    mostrarAssistente: mostrarAssistente,
    onAbrirAssistente: onAbrirAssistente
  });
  if (!mostrarHelpdesk && !mostrarAssistente) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactDraggable["default"], {
    bounds: "html",
    defaultPosition: {
      x: axis.x,
      y: axis.y
    },
    onDrag: function onDrag(e, _ref2) {
      var lastX = _ref2.lastX,
        lastY = _ref2.lastY,
        x = _ref2.x,
        y = _ref2.y;
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(function () {
        var currX = (lastX !== undefined ? lastX : x) || 0;
        var currY = (lastY !== undefined ? lastY : y) || 0;
        var diffX = Math.abs(axis.x - currX);
        var diffY = Math.abs(axis.y - currY);
        if (diffX < 0.6 && diffY < 0.6) {
          setTooltipIsOpen(function (open) {
            return !open;
          });
          return false;
        } else {
          setTooltipIsOpen(false);
          setAxis({
            x: currX,
            y: currY
          });
        }
      }, 10);
    },
    onStop: function onStop(e, _ref3) {
      var lastX = _ref3.lastX,
        lastY = _ref3.lastY,
        x = _ref3.x,
        y = _ref3.y;
      var nx = (lastX !== undefined ? lastX : x) || 0;
      var ny = (lastY !== undefined ? lastY : y) || 0;
      setAxis({
        x: nx,
        y: ny
      });
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          x: nx,
          y: ny
        }));
      } catch (err) {
        // ignore
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_SttBox["default"], {
    className: classes.boxMenu,
    onClick: eventHandler(onClick),
    onTouchStart: eventHandler(onClick),
    onMouseEnter: function onMouseEnter() {
      return setTooltipIsOpen(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setTooltipIsOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_SttHidden["default"], {
    smDown: true
  }, /*#__PURE__*/_react["default"].createElement(_SttBox["default"], {
    className: classes.tooltipContent
  }, /*#__PURE__*/_react["default"].createElement(HtmlTooltip, {
    placement: "top-end",
    open: tooltipIsOpen,
    arrow: true,
    interactive: true,
    title: conteudoTooltip
  }, atendenteOnline ? /*#__PURE__*/_react["default"].createElement("img", {
    src: _atendenteOnline["default"],
    style: {
      maxWidth: '65px',
      maxHeight: '65px'
    }
  }) : /*#__PURE__*/_react["default"].createElement("img", {
    src: _atendenteOffline["default"],
    style: {
      maxWidth: '65px',
      maxHeight: '65px'
    }
  })))), /*#__PURE__*/_react["default"].createElement(_SttHidden["default"], {
    mdUp: true
  }, /*#__PURE__*/_react["default"].createElement(_SttBox["default"], {
    className: classes.tooltipContent
  }, /*#__PURE__*/_react["default"].createElement(HtmlTooltip, {
    placement: "top-end",
    open: tooltipIsOpen,
    arrow: true,
    onOpen: function onOpen() {
      return setTooltipIsOpen(true);
    },
    onClose: function onClose() {
      return setTooltipIsOpen(false);
    },
    leaveTouchDelay: 5000,
    interactive: true,
    title: conteudoTooltip
  }, atendenteOnline ? /*#__PURE__*/_react["default"].createElement("img", {
    src: _atendenteOnline["default"],
    style: {
      maxWidth: '65px',
      maxHeight: '65px'
    }
  }) : /*#__PURE__*/_react["default"].createElement("img", {
    src: _atendenteOffline["default"],
    style: {
      maxWidth: '65px',
      maxHeight: '65px'
    }
  })))), mostrarHelpdesk && /*#__PURE__*/_react["default"].createElement("iframe", {
    referrerPolicy: "unsafe-url",
    src: "".concat(config.url_base_oauth2, "/AtalhoHelpdesk?modulo=").concat(config.modulo_sigla),
    style: {
      width: '0',
      height: '0',
      border: 0,
      position: 'relative'
    }
  }))), mostrarAssistente && /*#__PURE__*/_react["default"].createElement(_SttAssistenteChat["default"], {
    aberto: assistenteAberto,
    onFechar: function onFechar() {
      return setAssistenteAberto(false);
    },
    config: config,
    headers: headers
  }));
};
var _default = AtalhoHelpdesk;
exports["default"] = _default;